var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoltarTopo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "voltar_topo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Home_Escuro",
    transform: "translate(-344.000000, -2163.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0.000000, 1997.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "voltar_topo",
    transform: "translate(345.000000, 167.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,9.1 C26,2.6 23.4,0 16.9,0 L9.1,0 C2.6,0 0,2.6 0,9.1 L0,16.9 C0,23.4 2.6,26 9.1,26 L16.9,26 C23.4,26 26,23.4 26,16.9 L26,9.1 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2390381,15.6 L13.0390381,10.4 L7.83903809,15.6",
    id: "Vector"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltarTopo);
export default __webpack_public_path__ + "static/media/voltar_topo.3278cfdef1dd170215bd44ea2b097446.svg";
export { ForwardRef as ReactComponent };